<template>
  <page-header-wrapper>
    <div class="back-content">
      <a-tabs
        class="back-content-tabs"
        :default-active-key="selectedTab"
        :active-key="selectedTab"
        :animated="false"
        @change="tabChange"
      >
        <a-tab-pane
          v-for="tab in tabs"
          :key="tab.key"
          :tab="tab.title"
        >
          <component :is="tab.component" />
        </a-tab-pane>
        <!-- <div slot="tabBarExtraContent">
          <TableActions
            :actions="tabActions"
            @releaseResource="grantModal"
            @recoverResource="recoverModal"
          />
        </div> -->
      </a-tabs>
      <!-- <ReleaseResourceModal
        :visible="modalVisible"
        :loading="confirmLoading"
        @cancel="handleCancel"
        @ok="handleOk"
      />
      <RecoverResourceModalVue
        :visible="recoverVisible"
        :loading="confirmLoading"
        @cancel="handleCancel"
        @ok="handleOk"
      /> -->
    </div>
  </page-header-wrapper>
</template>

<script>
import FlowDetail from './FlowDetail.vue'
// import ReleaseResourceModal from './ReleaseResourceModal.vue'
// import RecoverResourceModalVue from './RecoverResourceModal.vue'

const settingTabs = [
  {
    title: '资源发放详情',
    key: 'detail',
    component: 'FlowDetail'
  }
]

// const tabActions = [
//   {
//     title: '发放资源',
//     type: 'primary',
//     action: 'releaseResource'
//   },
//   {
//     title: '回收资源',
//     type: 'primary',
//     action: 'recoverResource'
//   }
// ]

export default {
  components: {
    FlowDetail
    // ReleaseResourceModal,
    // RecoverResourceModalVue
  },
  data () {
    return {
      // tabActions,
      tabs: settingTabs,
      selectedTab: '',
      modalVisible: false,
      // recoverVisible: false,
      confirmLoading: false
    }
  },
  watch: {
    '$route.query.tab': {
      handler: function (val) {
        this.setSelectedTab()
      }
    }
  },
  created () {
    this.setSelectedTab()
  },
  methods: {
    setSelectedTab () {
      if (this.$route.query && this.$route.query.tab) {
        this.selectedTab = this.$route.query.tab
      } else {
        this.selectedTab = this.tabs[0].key
      }
    },
    tabChange (activeKey) {
      this.$router.push({
        name: 'dispenseflow',
        query: {
          tab: activeKey
        }
      })
    }
    // 发放资源弹窗
    // grantModal () {
    //   this.initData = {
    //     startDate: null,
    //     endDate: null,
    //     recoveryDate: null,
    //     enterpriseName: null,
    //     baseName: '',
    //     productTypeId: '',
    //     taxRate: null,
    //     remark: null,
    //     cloudAccount: null,
    //     email: null,
    //     contactName: null,
    //     contactPhone: null,
    //     productId: null,
    //     subsidyAmount: null
    //   }
    //   this.modalVisible = true
    // },
    // recoverModal () {
    //   this.recoverVisible = true
    // },
    // handleOk () {
    //   this.handleCancel()
    // },
    // handleCancel () {
    //   this.modalVisible = false
    //   this.recoverVisible = false
    //   // this.$emit('cancel')
    // }
  }
}
</script>
